import { useTranslations } from "ilenia";

import { PrimaryNavLinks } from ".";
import { trackingConst } from "../../../../constants";
import { useAnalytics } from "../../../../utils/analytics";
import { Item } from "../../types";
import { keyboardEnterOrSpaceClick } from "../../utils";

//Render primary navigation link with sub navigation
const PrimaryNavWithSubNav = ({
  menu,
  openPrimarySubMenu,
}: {
  menu: Item;
  openPrimarySubMenu: (menu: Item, event: unknown) => void;
}) => {
  const analytics = useAnalytics();
  const [translations] = useTranslations();

  return (
    <span
      role="button"
      onClick={(event: unknown) => {
        openPrimarySubMenu(menu, event);

        analytics.track(trackingConst.events.buttonClicked, {
          id: menu.id,
          name: trackingConst.names.navigationToggled,
          context: trackingConst.contexts.appshell,
        });
      }}
      onKeyDown={(event) => {
        keyboardEnterOrSpaceClick(event, () => openPrimarySubMenu(menu, event));

        analytics.track(trackingConst.events.buttonClicked, {
          id: menu.id,
          name: trackingConst.names.navigationToggled,
          context: trackingConst.contexts.appshell,
        });
      }}
      tabIndex={0}
      aria-label={`${translations["ButtonAriaLabels.openSubmenu"]} ${translations[`Sidebar.${menu.id}`]}`}
    >
      <PrimaryNavLinks menu={menu} />
    </span>
  );
};

export default PrimaryNavWithSubNav;
